<div class="ap canvas-small">
    <error-notification></error-notification>
    <ap-panel class="ap-margin-bottom-0">
        <div ap-panel-body>
            <div class="ap-flex ap-flex-sm-wrap ap-flex-gap-3">
                <div class="ap-flex-basis-sm-100 ap-flex-basis-50">
                    <main-accordion></main-accordion>
                </div>

                @if (mortgageCalculationService.showDesktopOrMobileDisplay()) {
                    <div class="ap-flex-basis-sm-100 ap-flex-basis-50">
                        <mortgage-calculation></mortgage-calculation>
                    </div>
                }

                @if (mortgageCalculationService.showMobileDisplay()) {
                    <div class="ap-flex-column">
                        @if (showButton()) {
                            <next-button (click)="nextQuestion()" [contentKey]="'global.continue-button.max-mortgage.text'"></next-button>
                        }
                        <ap-appointment-button></ap-appointment-button>
                    </div>
                }
            </div>
            @if (mortgageCalculationService.showAccordion()) {
                <calculation-details [mortgageCalculation]="store.getMortgage() | async"></calculation-details>
            }
        </div>
    </ap-panel>

    @if (mortgageCalculationService.showStickyMobileDisplay()) {
        <mortgage-calculation class="sticky"></mortgage-calculation>
    }
</div>
